import { BoxProps } from '@chakra-ui/react';
import { rest } from 'lodash';
import React from 'react';

import { CmBox, CmFormLabel } from '@/components/uiParts';

interface Props extends BoxProps {
  isChecked: boolean;
  uniqueGroupId: string;
  onClick?: React.FormEventHandler<HTMLDivElement>;
}
export const RadioCard: React.FC<Props> = ({
  isChecked,
  uniqueGroupId,
  onClick,
  children,
}) => {
  return (
    <CmFormLabel htmlFor={uniqueGroupId} margin="0" cursor="pointer">
      <CmBox
        role="radio"
        id={uniqueGroupId}
        aria-checked={isChecked}
        p="16px"
        bg="white"
        color="black"
        borderWidth="1px"
        borderColor="gray.400"
        _checked={{
          borderColor: 'green.200',
          borderWidth: '4px',
          p: '13px',
        }}
        borderRadius="4px"
        position="relative"
        {...{ onClick, ...rest }}
      >
        {children}
      </CmBox>
    </CmFormLabel>
  );
};
